import { FC } from 'react';
import { useJudgeForCategory } from '@doda/common/src/hooks/JobContent/JobTrend/useJudgementForLeadText';
import { LABEL_FLAG } from '@doda/common/src/constants/seo/jobTrendConstants';
import { createRankingLabel } from '@doda/common/src/logics/JobContent/JobTrend/createLabel';
import styles from './index.module.scss';

/**
 * BargraphLeadTextのProps
 * @param targetName ページに訪れたパラメータの項目名
 * @param jobData 整形されたカテゴリごとの求人数配列
 * @param jobLabel 整形されたカテゴリごとの項目名配列
 * @param flg どのカテゴリかを判定するためのフラグ
 */
interface Props {
  targetName: string;
  jobData: number[];
  jobLabel: string[];
  flg: string;
}

export const BargraphLeadText: FC<Props> = ({
  targetName,
  jobData,
  jobLabel,
  flg,
}) => {
  let resultText;
  let name;
  const category = useJudgeForCategory(flg);
  if (category) {
    name = `「${category}」別の`;
  } else {
    name = `「${targetName}」の`;
  }
  // 年収、設立、平均年齢をソートしなければならない
  if (
    flg === LABEL_FLAG.INCOME ||
    flg === LABEL_FLAG.ESTABLISH ||
    flg === LABEL_FLAG.EMPLOYEE_AVERAGE_AGE
  ) {
    const combinedArray = jobData.map((item, index) => [item, jobLabel[index]]);
    combinedArray.sort((a, b) => Number(b[0]) - Number(a[0]));
    jobData = combinedArray.map((item) => Number(item[0]));
    jobLabel = combinedArray.map((item) => String(item[1]));
  }

  const rankingCombinedArray = createRankingLabel(jobData, jobLabel, flg);

  if (rankingCombinedArray.length === 0 || rankingCombinedArray[0][0] === 0) {
    resultText = `dodaに掲載されている${name}求人では、該当する求人は0件です。`;
  } else if (
    rankingCombinedArray.length === 1 ||
    rankingCombinedArray[1][0] === 0
  ) {
    resultText = `dodaに掲載されている${name}求人では、${rankingCombinedArray[0][1]}が最も多く${rankingCombinedArray[0][0]}件です。`;
  } else if (
    rankingCombinedArray.length === 2 ||
    rankingCombinedArray[2][0] === 0
  ) {
    resultText = `dodaに掲載されている${name}求人では、${rankingCombinedArray[0][1]}が最も多く${rankingCombinedArray[0][0]}件です。2番目に求人が多いのは${rankingCombinedArray[1][1]}で${rankingCombinedArray[1][0]}件です。`;
  } else if (rankingCombinedArray.length >= 3) {
    resultText = `dodaに掲載されている${name}求人では、${rankingCombinedArray[0][1]}が最も多く${rankingCombinedArray[0][0]}件です。2番目に求人が多いのは${rankingCombinedArray[1][1]}で${rankingCombinedArray[1][0]}件です。3番目に求人が多いのは${rankingCombinedArray[2][1]}で${rankingCombinedArray[2][0]}件です。`;
  }

  return <div className={styles.bargraphLeadText}>{resultText}</div>;
};
